import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于天堂影院的使用说明和常见疑问解答
          </p>
        </div>
        <div className="space-y-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-medium text-foreground-800 mb-3 flex items-start gap-3">
                <span className="text-accent-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-line"></i>
                </span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-8">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}